import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'
import Trash from 'react-icons/lib/md/delete'
import acc from 'accounting'

import ConfirmDialog from 'components/ConfirmDialog'
import { deleteFee } from './actions'

class BillingItem extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showConfirm: false,
      pending: false,
    }
  }

  _showConfirm = () => {
    this.setState({
      showConfirm: true,
    })
  }

  _hideConfirm = () => {
    this.setState({
      showConfirm: false,
    })
  }

  _onRemove = () => {
    const { dispatch, item, studentID } = this.props
    this.setState({
      pending: true,
    })
    dispatch(deleteFee(studentID, item.get('billing_id'), item.get('id')))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('billingHeaderState', fromJS(res.payload.header || {})))
          this._hideConfirm()
        }
      })
  }

  _renderConfirm() {
    const { showConfirm, pending } = this.state
    const { item } = this.props

    if (!showConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg={`Are you sure you want to remove ${item.get('fee_name')}?`}
        closeDialog={this._hideConfirm}
        confirmAction={this._onRemove}
        btnClass="btn-danger"
        pending={pending}
      />
    )
  }

  render() {
    const { item } = this.props
    return (
      <tr>
        <td><button type="button" onClick={this._showConfirm} className="btn-inline btn-icon"><Trash /></button></td>
        <td>{item.get('fee_name')}</td>
        <td className="text-right">
          {acc.formatNumber(item.get('amount'), 2)}
          {this._renderConfirm()}
        </td>
      </tr>
    )
  }
}

export default connect()(BillingItem)



// WEBPACK FOOTER //
// ./src/containers/Billing/billing-item.js